import React from 'react';
import { Phone, MessageCircle, FileText } from 'lucide-react';
import { businessInfo } from '../data/mock';

const StickyFooter = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <div className="bg-white border-t border-slate-200 shadow-2xl">
        <div className="grid grid-cols-3">
          <a 
            href={`tel:${businessInfo.phone}`}
            className="flex flex-col items-center justify-center py-3 text-slate-600 hover:text-amber-600 hover:bg-amber-50 transition-colors"
          >
            <Phone className="w-5 h-5 mb-1" />
            <span className="text-xs font-medium">Call</span>
          </a>
          
          <a 
            href={`https://wa.me/${businessInfo.whatsapp}?text=Hi%2C%20I%27m%20interested%20in%20getting%20a%20quote%20from%20Expert-Plasterer.`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center py-3 text-slate-600 hover:text-green-600 hover:bg-green-50 transition-colors"
          >
            <MessageCircle className="w-5 h-5 mb-1" />
            <span className="text-xs font-medium">WhatsApp</span>
          </a>
          
          <a 
            href="#contact"
            className="flex flex-col items-center justify-center py-3 bg-amber-500 text-white"
          >
            <FileText className="w-5 h-5 mb-1" />
            <span className="text-xs font-medium">Get Quote</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default StickyFooter;
